import React from 'react';
import { Link } from 'anf-core-react';

const ProductNotificationsLegalLinks = ({ config, tmntData }) => {
  if (!config || !tmntData) return null;

  const validLinks = ['termsOfUse', 'privacyPolicy'].filter(
    (key) => config[key] && tmntData[key]?.value,
  );

  if (!validLinks.length) return null;

  return (
    <div className="product-notifications-legal-links">
      {validLinks.map((key, index) => (
        <React.Fragment key={key}>
          <Link
            classList="product-notifications-legal-link"
            href={config[key]}
            target="_blank"
            theme="default"
          >
            {tmntData[key].value}
          </Link>
          {index < validLinks.length - 1 && <span className="legal-link-separator"> | </span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProductNotificationsLegalLinks;
